import * as R from 'ramda'
import { TYPE_POLL } from 'app/constants/messageType'
import { FACEBOOK_VALUE, INSTAGRAM_VALUE } from 'app/constants/channel'

const filterPageIds = (pages) => {
  if (!Array.isArray(pages)) return []

  return pages.filter((page) => {
    return page.channel === FACEBOOK_VALUE || page.channel === INSTAGRAM_VALUE
  })
}

export const mapDraftPayloadToNotification = (draftResponse) => {
  const draftData = R.prop('data', draftResponse) || draftResponse

  const translation = R.prop('translation', draftData)
  const translations = translation
    ? [
        {
          languageId: translation.languageId,
          languageCode: translation.languageCode,
          title: translation.title || '',
          body:
            translation.fullBody ||
            translation.body ||
            translation.description ||
            '',
          description:
            translation.description ||
            translation.fullBody ||
            translation.body ||
            '',
          descriptionPreview: translation.descriptionPreview || '',
        },
      ]
    : []

  const poll = R.prop('poll', draftData)
  let transformedPoll = null
  if (poll) {
    const pollTimezone = poll.endTimezone || draftData.timezone || 'UTC'
    let pollEndDate = null
    if (poll.endDate) {
      if (typeof poll.endDate === 'object' && poll.endDate !== null) {
        pollEndDate = poll.endDate
      } else if (
        typeof poll.endDate === 'string' &&
        poll.endDate.trim() !== ''
      ) {
        pollEndDate = {
          dateTime: poll.endDate,
          timeZone: pollTimezone,
        }
      }
    }

    transformedPoll = {
      ...poll,
      options: R.map(
        (option) => ({
          id: option.id,
          title: option.title || '',
          imagePath: option.imageURL || option.imagePath || null,
          imageURL: option.imageURL || null,
        }),
        poll.options || [],
      ),
      endDate: pollEndDate,
      endTimezone: pollTimezone,
    }
  }

  const transformedNotification = {
    ...R.omit(['translation', 'groups', 'recipients'], draftData),
    translations,
    poll: transformedPoll,
    type: draftData.type || draftData.notiType,
    isDraft:
      draftData.isDraft === true
        ? 1
        : draftData.isDraft === false
          ? 0
          : draftData.isDraft,
    scheduleDate:
      draftData.isScheduled === true
        ? draftData.scheduleDate || draftData.sendDate
        : null,
    scheduleTimezone: draftData.timezone || 'UTC',
    reminderDate: draftData.reminderDate,
    reminderTimezone: draftData.timezone || 'UTC',
    startTime: draftData.event?.startDateTime || null,
    endTime: draftData.event?.endDateTime || null,
    startTimezone: draftData.timezone || 'UTC',
    endTimezone: draftData.timezone || 'UTC',
    address: draftData.event?.address || null,
    latitude: draftData.event?.latitude || draftData.latitude || null,
    longitude: draftData.event?.longitude || draftData.longitude || null,
    channels: R.defaultTo([], draftData.channels),
    pageIds: filterPageIds(draftData.socialChannels),
    subGroups: Array.isArray(draftData.groups)
      ? draftData.groups.map((groupItem) => ({
          id: groupItem.tagId,
          groupId: groupItem.group?.id || null,
          name: groupItem.tagName,
          group: groupItem.group || null,
          deletedAt: null,
        }))
      : draftData.subGroups || [],
    subscribers: draftData.recipients || [],
    placeTopics: Array.isArray(draftData.topics)
      ? draftData.topics.map((topic) => ({
          id: topic.id,
          name: topic.name || '',
          isSelected: true,
        }))
      : [],
    mediaSocials: draftData.mediaSocials || [],
    medias: draftData.medias || [],
    voucher: draftData.voucher,
    expirationTime: draftData.expiration?.seconds || null,
    beaconSchedule: draftData.beaconSchedule || {
      start_date: null,
      end_date: null,
      range: null,
      range_unit: null,
      frequency_type: null,
      duration: null,
      start_timezone: null,
    },
    beacons: draftData.beacons || [],
  }

  return transformedNotification
}
